const func = {
  /**
   *  导入，导出
   */
  exportComponentByIds: function (a) {
    if (a.length == 0) {
      PF.message('warning', '请选择需要导出的数据');
      return;
    }
    let ids = [];
    a.forEach(v=> {
      ids.push(v.id);
    })
    PF.api.app.exportComponentByIds(ids);
  },

  importComponentByIds: function (a, b) {
    PF.show('importComp', {}, (v)=> {
      b.refreshTable();
    });
  },

}

export default func





// WEBPACK FOOTER //
// ./src/modules/index/common/viewFunction.js